/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-escape */
import React, { useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { Modal, Select, Drawer } from 'antd';
import { DrawerHeader, Header, ModalHeader } from 'datastake-daf/dist/components';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { StorageManager } from "datastake-daf/src/helpers/StorageManager";
import { actions as sclActions } from '../../store/reducers/scl';
import { actions as lirActions } from '../../store/reducers/lir';
import { actions as stkActions } from '../../store/reducers/stakeholder';
import { actions as eventActions } from '../../store/reducers/events';
import { actions as documentActions } from '../../store/reducers/documents';
import { actions as projectActions } from '../../store/reducers/project';
import { actions as spActions } from '../../store/reducers/sp';
import { actions as imActions } from '../../store/reducers/im';
import { actions as sciActions } from '../../store/reducers/sci';
import { actions as bpeActions } from '../../store/reducers/bpe';
import { actions as gmActions } from '../../store/reducers/gm';
import Navigation from './navigation';
import Content from './content';
import { Template } from './templates';
import { groupSubsections } from './helper';
import { displayMessage } from '../../helpers/Messages';
import { canViewFeatureAction } from '../../constants/roles';
import { isClient } from '../../routes/ModuleRouter';
import ProjectCreate from '../../components/Forms/projects/create';
import NotFound from '../../components/NotFound';
import Loading from '../../components/Loading';
import { PROJECTS } from '../../helpers/CanAccess';
import Style from './style';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import { getPopupContainer } from '../../helpers/popUp';
import { checkPermission } from '../../permissions/usePermissions';
import { renderBreadCrumbs } from '../../helpers/breadCrumbs';
import { CREATE_DRAWER_WIDTH } from '../../helpers/form';
import ViewTIF from '../ViewTIF';

export const analysisNamespaces = ['kyc', 'scp', 'mine-operators', 'scl'];
const linkingSubjects = [
  'scl',
  'location',
  'village',
  'event',
  'incidents',
  'corrective-actions',
  'stakeholder',
  'scp',
  'mine-operators',
  'lir',
];

const actions = {
  ...sclActions,
  ...lirActions,
  ...stkActions,
  ...eventActions,
  ...documentActions,
  ...projectActions,
  ...spActions,
  ...imActions,
  ...sciActions,
  ...bpeActions,
  ...gmActions,
};

const emptyArr = [];

const View = ({
  stakeholder: { data: stakeholderData, viewConfig: stakeholderView },
  scl: { data: sclData, viewConfig: sclView },
  events: { data: eventData, viewConfig: eventView },
  documents: { data: documentData, viewConfig: documentView },
  lir: { data: lirData, viewConfig: lirView },
  project: { data: projectData, viewConfig: projectView },
  sp: { data: spData, viewConfig: spView },
  im: { data: imData, viewConfig: imView },
  sci: { data: sciData, viewConfig: sciView },
  bpe: { data: bpeData, viewConfig: bpeView },
  gm: { data: gmData, viewConfig: gmView },
  authentication: { user, selectedProject: selProject },
  stakeholderDataGet,
  SCLDataGet,
  eventsDataGet,
  documentsDataGet,
  lirDataGet,
  spDataGet,
  imDataGet,
  sciDataGet,
  bpeDataGet,
  gmDataGet,
  ProjectDataGet,
  ProjectRemove,
  eventsRemove,
  documentsRemove,
  sclRemove,
  stakeholderRemove,
  lirRemove,
  mode = 'app',
}) => {
  const selectedProject = selProject;
  const supportedNamespaces = {
    cadd: [
      'stakeholder', 'scp', 'location', 'scl', 'village', 'project', 'event', 'incidents', 'corrective-actions', 'document', 'lir', 'kyc', 'sp', 'im', 'sci', 'bpe', 'gm',
    ],
    tif: [
      'stakeholder', 'scp', 'mine-operators', 'location', 'scl', 'village', 'project', 'event', 'incidents', 'corrective-actions', 'document', 'lir', 'kyc', 'sp', 'im', 'sci', 'bpe', 'gm'
    ],
    pme: [
      'stakeholder', 'scp', 'location', 'scl', 'village', 'project', 'event', 'incidents', 'corrective-actions', 'document', 'lir', 'kyc', 'sp', 'im', 'sci', 'bpe', 'gm'
    ]
  }

  const push = useNavigate();
  const allData = { stakeholderData, sclData, eventData, lirData, projectData, spData, imData, sciData, bpeData, gmData };
  const allView = { stakeholderView, sclView, eventView, lirView, projectView, spView, imView, sciView, bpeView, gmView };
  // const { namespace, id, group, subsection, subgroup } = useParams();
  const params = useParams();
  const [namespace, setNamespace] = useState(params.namespace);
  const [id, setId] = useState(params.id);
  const [group, setGroup] = useState(params.group);
  const [subsection, setSubSection] = useState(params.subsection);
  // const [subgroup, setSubGroup] = useState(params.subgroup);

  const { t } = useTranslation();
  const { pathname, search } = useLocation();
  const [form, setForm] = useState({});
  const [data, setData] = useState({});
  const [groups, setGroups] = useState({});
  const [linkingForms, setLinkingForms] = useState({});
  const [viewConfig, setViewConfig] = useState({});
  const [loading, setLoading] = useState(true);
  const [deletionVisible, setDeletionVisible] = useState(false);
  const [deletionReason, setDeletionReason] = useState(null);
  const [sProject, setSProject] = useState(null);
  const [headerTags, setHeaderTags] = useState([]);
  const [inviteClient, setInviteClient] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [language, setLanguage] = useState(user.language);
  const [, module] = mode === 'proxy' ?
    pathname.split(/\/proxy\/(pme|cadd|tif)\/view/)
    : pathname.split(/\/app\/(pme|cadd|tif)\/view/);
  const [extraPageActions, setExtraPageActions] = useState([]);
  const [pageActions, setPageActions] = useState([]);
  // const excludedKeys = ['id', 'userId', 'position', 'authorId', 'label', 'outputLabel', 'icon', 'sectionLabel', 'formDescription', 'introText', 'alertConf', 'showFormIf', 'excludeFromEdit'];
  const isSupported = (supportedNamespaces[module] && supportedNamespaces[module].includes(namespace));
  const queryParam = new URLSearchParams(search);
  const version = queryParam.get('version') || undefined;
  let sourceId = queryParam.get('sourceId') || undefined;
  if (!sourceId && localStorage.getItem('source')) {
    sourceId = localStorage.getItem('source');
  }
  const getEditLink = () => {
    const r = new RegExp(`\/view\/`);
    const [previous, extra] = pathname.split(r);
    push(`${previous}/edit/${extra}`);
  }

  const match = useMemo(() => ({
    params,
    path: pathname,
  }), [params, pathname]);

  const getRiskEditLink = (category, subCategory) => {
    const url = `/${mode}/${module}/edit/${namespace}/${id}/risk/${category}/${subCategory}`;
    push(url);
  }

  const isProjectApproved = () => {
    return data &&
      data.id &&
      user &&
      user.projects &&
      Array.isArray(user.projects) &&
      user.projects.filter(p => p.id === data.id && p.status === 'approved').length === 1 ? true : false;
  }
  const isUserData = () => {
    return data && data.authorId && (user?.company?.id === data.authorId)
  }
  const canEditAction = {
    stakeholder: () => checkPermission({ permission: 'stakeholders.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    scp: () => checkPermission({ permission: 'stakeholders.SCA.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    // TO-DO add permissions
    'mine-operators': () => true && isUserData(),
    location: () => checkPermission({ permission: 'locations.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    scl: () => checkPermission({ permission: 'locations.mineSites.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    village: () => checkPermission({ permission: 'locations.villages.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    project: () => checkPermission({ permission: 'projects.canEdit', permissions: user?.role?.permissions }) &&
      !user?.company?.id &&
      isProjectApproved() && canViewFeatureAction({ user, module, feature: 'projects', action: 'edit' }) && (
        isClient(user) || (data && data.authorId && data.authorId === user?.company?.id)
      ),
    event: () => checkPermission({ permission: 'events.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    incidents: () => checkPermission({ permission: 'events.incidents.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    'corrective-actions': () => checkPermission({ permission: 'events.correctiveActions.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    document: () => checkPermission({ permission: 'documents.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    lir: () => checkPermission({ permission: 'stakeholders.LIR.canEdit', permissions: user?.role?.permissions })
      && data && data.authorId && (user?.company?.id === data.authorId),
    kyc: () => checkPermission({ permission: 'myOrganisation.KYC.canEdit', permissions: user?.role?.permissions })
      && (isUserData() || !data.authorId),
    sp: () => checkPermission({ permission: 'myOrganisation.DDSystems.SCP.canEdit', permissions: user?.role?.permissions }) &&
      (isUserData() || !data.authorId),
    im: () => checkPermission({ permission: 'myOrganisation.DDSystems.internalManagement.canEdit', permissions: user?.role?.permissions }) &&
      (isUserData() || !data.authorId),
    sci: () => checkPermission({ permission: 'myOrganisation.DDSystems.SCP.canEdit', permissions: user?.role?.permissions }) &&
      (isUserData() || !data.authorId),
    bpe: () => checkPermission({ permission: 'myOrganisation.DDSystems.supplierEngagement.canEdit', permissions: user?.role?.permissions }) &&
      (isUserData() || !data.authorId),
    gm: () => checkPermission({ permission: 'myOrganisation.DDSystems.grievanceMechanism.canEdit', permissions: user?.role?.permissions }) &&
      (isUserData() || !data.authorId),
  }

  const canDeleteAction = {
    stakeholder: checkPermission({ permission: 'stakeholders.canDelete', permissions: user?.role?.permissions }),
    scp: checkPermission({ permission: 'stakeholders.SCA.canDelete', permissions: user?.role?.permissions }),
    // TO-DO add permissions
    'mine-operators': true,
    location: checkPermission({ permission: 'locations.canDelete', permissions: user?.role?.permissions }),
    scl: checkPermission({ permission: 'locations.mineSites.canDelete', permissions: user?.role?.permissions }),
    project: checkPermission({ permission: 'projects.canDelete', permissions: user?.role?.permissions }),
    event: checkPermission({ permission: 'events.canDelete', permissions: user?.role?.permissions }),
    'corrective-actions': checkPermission({ permission: 'events.correctiveActions.canDelete', permissions: user?.role?.permissions }),
    incidents: checkPermission({ permission: 'events.incidents.canDelete', permissions: user?.role?.permissions }),
    document: checkPermission({ permission: 'documents.canDelete', permissions: user?.role?.permissions }),
    lir: checkPermission({ permission: 'stakeholders.LIR.canDelete', permissions: user?.role?.permissions }),
    village: checkPermission({ permission: 'locations.villages.canDelete', permissions: user?.role?.permissions }),
  }

  const canInviteCustomer = !user?.company?.id
    && namespace === 'project'
    && !isClient(user)
    && isProjectApproved()
    && canViewFeatureAction({
      user,
      module: 'pme',
      feature: 'projects',
      action: 'inviteCustomer'
    });

  const riskActions = () => {
    const actions = [];
    const tags = [];

    const url = window.location.href;

    const group = url.split('/risk/');
    if (group && group[1]) {
      const subgroups = group[1].split('/');
      if (subgroups) {
        const category = subgroups[0];
        const subCategory = subgroups[1];

        tags.push({
          label: id,
        });

        if (canEditAction[namespace]() && selectedProject === PROJECTS.myData) {
          if (subCategory && subCategory.length) {
            actions.push({
              type: "primary",
              onClick: () => getRiskEditLink(category, subCategory),
              label: t('Edit'),
            })
          }
        }
      }
    }

    return { actions, tags };
  };

  const groupForm = useMemo(() => {
    const gF = form[group] || {};
    if (subsection) {
      const sectionForms = groupSubsections(gF);
      if (sectionForms[subsection]) {
        return sectionForms[subsection];
      }
    }
    return gF;
  }, [form, group, subsection]);

  const noDeleteButtonOnNamespaces = ['kyc', 'sp', 'im', 'sci', 'bpe', 'gm'];

  // params
  useEffect(() => {
    if ((id && params.id !== id) || (namespace && namespace !== params.namespace)) {
      setGroup(undefined);
      setSubSection(undefined);
      // setSubGroup(undefined);
    } else {
      setGroup(params.group);
      setSubSection(params.subsection);
      // setSubGroup(params.subgroup);
    }
    setNamespace(params.namespace);
    setId(params.id);
  }, [params]);

  const goToAssessmentScp = (id, sourceId) => {
    let str = `/${mode}/${module}/analysis/scp/${id}`;
    if (sourceId && sourceId !== 'overview') {
      str += `/${sourceId}`;
    }
    push(str);
  };

  const goToAssessmentMineOperators = (id, sourceId) => {
    let str = `/${mode}/${module}/analysis/mine-operators/${id}`;
    if (sourceId && sourceId !== 'overview') {
      str += `/${sourceId}`;
    }
    push(str);
  };

  const goToAssessmentScl = (id, sourceId) => {
    let str = `/${mode}/${module}/analysis/scl/${id}`;
    if (sourceId && sourceId !== 'overview') {
      str += `/${sourceId}`;
    }
    push(str);
  };

  const goToAssessmentKyc = () => {
    push(`/${mode}/${module}/analysis/kyc`);
  };

  const isAnalysis = useMemo(() => {
    const showKyc = namespace === 'kyc' ? module === 'cadd' : true;
    return analysisNamespaces.includes(namespace) && showKyc
  }, [namespace]);

  useEffect(() => {
    const tags = [];
    const actions = [];
    const extraActions = [];

    if (isSupported) {
      if (groupForm.template === 'risk') {
        const riskConf = riskActions();
        setHeaderTags(riskConf.tags);
        setPageActions(riskConf.actions);
        return;
      }

      if (canEditAction[namespace]() && selectedProject === PROJECTS.myData && !isAnalysis) {
        actions.push({
          label: t('Edit'),
          type: 'primary',
          onClick: () => getEditLink(),
        })

        if (mode !== 'proxy') {
          // TO-DO
          if (data && data.id && !noDeleteButtonOnNamespaces.includes(namespace) && canDeleteAction[namespace]) {
            extraActions.push({
              label: t('Delete'),
              type: 'danger',
              onClick: () => setDeletionVisible(true),
            })
          }
        }
        if (canInviteCustomer) {
          extraActions.push({
            label: t('Invite Client'),
            onClick: () => setInviteClient(true),
          })
        }
      }
      // if (!isAnalysis) {
      //   (viewConfig.tags || []).forEach(tag => {
      //     tags.push({
      //       ...tag,
      //       label: tag.value,
      //     })
      //   });
      // } else if (id !== 'user') {
      //   tags.push({ label: id });
      // }

      if (id !== 'user') {
        tags.push({ label: id });
      }

      if (canEditAction[namespace]() && selectedProject === PROJECTS.myData && isAnalysis) {
        actions.push({
          label: t('Edit'),
          type: 'primary',
          onClick: () => getEditLink(),
        })
      }

      if (isAnalysis) {
        actions.push({
          label: t('Analysis'),
          onClick: () => {
            if (namespace === 'kyc') {
              goToAssessmentKyc()
            } else if (namespace === 'scp') {
              goToAssessmentScp(data.datastakeId, sourceId);
            } else if (namespace === 'mine-operators') {
              goToAssessmentMineOperators(data.datastakeId, sourceId);
            } else if (namespace === 'scl') {
              goToAssessmentScl(data.datastakeId, sourceId);
            }
          },
        });
      }

      setHeaderTags(tags);
      setPageActions(actions);
      setExtraPageActions(extraActions)
    }
  }, [namespace, data, pathname, group]);

  const dataKey = {
    stakeholder: 'stakeholderData',
    scp: 'stakeholderData',
    'mine-operators': 'stakeholderData',
    location: 'sclData',
    scl: 'sclData',
    village: 'sclData',
    event: 'eventData',
    incidents: 'eventData',
    'corrective-actions': 'eventData',
    document: 'documentData',
    lir: 'lirData',
    project: 'projectData',
    kyc: 'stakeholderData',
    sp: 'spData',
    im: 'imData',
    sci: 'sciData',
    bpe: 'bpeData',
    gm: 'gmData',
  };

  const viewKey = {
    stakeholder: 'stakeholderView',
    scp: 'stakeholderView',
    'mine-operators': 'stakeholderView',
    location: 'sclView',
    scl: 'sclView',
    village: 'sclView',
    event: 'eventView',
    incidents: 'eventView',
    'corrective-actions': 'eventView',
    document: 'documentView',
    lir: 'lirView',
    project: 'projectView',
    kyc: 'stakeholderView',
    sp: 'spView',
    im: 'imView',
    sci: 'sciView',
    bpe: 'bpeView',
    gm: 'gmView',
  }

  const namespaceRemove = {
    stakeholder: stakeholderRemove,
    scp: stakeholderRemove,
    'mine-operators': stakeholderRemove,
    location: sclRemove,
    scl: sclRemove,
    village: sclRemove,
    event: eventsRemove,
    incidents: eventsRemove,
    'corrective-actions': eventsRemove,
    document: documentsRemove,
    lir: lirRemove,
    project: ProjectRemove,
  };

  const namespaceAllPath = {
    stakeholder: 'stakeholders',
    scp: 'scp',
    'mine-operators': 'mine-operators',
    location: 'locations',
    scl: 'scl',
    village: 'village',
    event: 'events',
    incidents: 'incidents',
    'corrective-actions': 'corrective-actions',
    document: 'documents',
    lir: 'lir',
    project: 'projects',
    kyc: '',
    sp: '',
    im: '',
    sci: '',
    bpe: '',
    gm: '',
  }
  const isDueDiligence = () => {
    return ['kyc', 'sp', 'im', 'sci', 'bpe', 'gm'].includes(namespace) && selectedProject !== PROJECTS.myData && id !== 'user';
  }
  const dueDiligence = (payload) => {
    if (isDueDiligence()) {
      payload.datastakeId = id;
      // payload.view = 'due-diligence';
    }
    return payload;
  }
  const namespaceGet = {
    stakeholder: () => stakeholderDataGet({
      namespace: 'Stakeholder',
      module,
      view: namespace.toLowerCase(),
      stakeholderId: id,
      version,
      sourceId,
    }),
    scp: () => stakeholderDataGet({
      namespace: 'Stakeholder',
      module,
      view: namespace.toLowerCase(),
      stakeholderId: id,
      version,
      sourceId,
    }),
    'mine-operators': () => stakeholderDataGet({
      namespace: 'Stakeholder',
      module,
      view: namespace.toLowerCase(),
      stakeholderId: id,
      version,
      sourceId,
    }),
    kyc: () => stakeholderDataGet(dueDiligence({
      namespace: 'Stakeholder',
      module,
      view: namespace.toLowerCase(),
      version,
      sourceId,
    })),
    location: () => SCLDataGet({
      namespace: 'SCL',
      module,
      view: 'scoping',
      sclId: id,
      version,
      sourceId,
    }),
    scl: () => SCLDataGet({
      namespace: 'SCL',
      module,
      view: 'scoping',
      sclId: id,
      version,
      sourceId,
    }),
    village: () => SCLDataGet({
      namespace: 'SCL',
      module,
      view: 'scoping',
      sclId: id,
      version,
      sourceId,
    }),
    event: () => eventsDataGet({
      namespace: 'Events',
      module,
      view: 'scoping',
      datastakeId: id,
      version,
      sourceId,
    }),
    incidents: () => eventsDataGet({
      namespace: 'Events',
      module,
      view: 'scoping',
      datastakeId: id,
      version,
      sourceId,
    }),
    'corrective-actions': () => eventsDataGet({
      namespace: 'Events',
      module,
      view: 'scoping',
      datastakeId: id,
      version,
      sourceId,
    }),
    document: () => documentsDataGet({
      namespace: 'Documents',
      module,
      view: 'scoping',
      datastakeId: id,
      version,
      sourceId,
    }),
    lir: () => lirDataGet({
      namespace: 'Lir',
      module,
      view: 'scoping',
      lirId: id,
      version,
      sourceId,
    }),
    project: () => ProjectDataGet({
      namespace: 'PMEProject',
      module,
      view: 'project',
      projectId: id,
      version,
      sourceId,
    }),
    sp: () => spDataGet(dueDiligence({
      namespace: 'SupplyChainPolicy',
      module,
      view: 'scoping',
      version,
      sourceId,
    })),
    im: () => imDataGet(dueDiligence({
      namespace: 'IMS',
      module,
      view: 'scoping',
      version,
      sourceId,
    })),
    sci: () => sciDataGet(dueDiligence({
      namespace: 'SCI',
      module,
      view: 'scoping',
      version,
      sourceId,
    })),
    bpe: () => bpeDataGet(dueDiligence({
      namespace: 'BPE',
      module,
      view: 'scoping',
      version,
      sourceId,
    })),
    gm: () => gmDataGet(dueDiligence({
      namespace: 'GM',
      module,
      view: 'scoping',
      version,
      sourceId,
    })),
  };
  const callToGetData = () => {
    if (isSupported) {
      namespaceGet[namespace]();
      setLanguage(user.language);
    }
  }
  const onStorageUpdate = (e) => {
    const { key, newValue } = e;
    if (key === `${id}-loading` && newValue) {
      setLoading(newValue);
    }
    if (key === `${id}-updated` && newValue) {
      setLoading(true);
      callToGetData();
    }
  };
  useEffect(() => {
    window.addEventListener("storage", onStorageUpdate);
    return () => {
      window.removeEventListener("storage", onStorageUpdate);
    };
  }, []);
  useEffect(() => {
    window.addEventListener("storage", onStorageUpdate);
    return () => {
      window.removeEventListener("storage", onStorageUpdate);
    };
  }, []);
  useEffect(() => {
    callToGetData();
  }, [id, namespace, user.language]);

  useEffect(() => {
    if (sProject && sProject !== selectedProject) {
      goToList();
    } else {
      setSProject(selectedProject);
    }
  }, [selectedProject])

  const prepareForm = (currentView) => {
    const dKey = dataKey[namespace];
    const nKey = `${module}-${currentView}`;
    if (hasKey(allData, dKey) && hasKey(allData[dKey], nKey)) {
      const { form = {}, data = {}, config = {}, linkingForms = {} } = JSON.parse(JSON.stringify(allData[dKey][nKey] || {}));
      if (data.datastakeId === id || id === 'user') {
        if (linkingSubjects.includes(namespace)) {
          setForm({
            ...form,
            linking: {
              position: 100,
              excludeFromEdit: true,
              label: t('Linked Subjects'),
              template: 'linkingSubjects',
            },
          });
        } else {
          setForm(form);
        }
        setData(data);
        setGroups(config.groups || {});
        setLinkingForms(linkingForms);
        setViewConfig(allView[viewKey[namespace]] || {});
        setLoading(false);
        setNotFound(false);
      } else if (!data.id) {
        if (mode === 'proxy' && sessionStorage.getItem('proxy_project') !== PROJECTS.myData) {
          sessionStorage.setItem('proxy_project', PROJECTS.myData);
          window.location.reload();
        } else {
          setLoading(false);
          setNotFound(true);
        }
      }
    }
  };

  useEffect(() => {
    if (['stakeholder', 'scp', 'mine-operators', 'kyc'].includes(namespace)) {
      prepareForm(namespace);
    }
  }, [stakeholderData])

  useEffect(() => {
    if (['location', 'scl', 'village'].includes(namespace)) {
      prepareForm('scoping');
    }
  }, [sclData])

  useEffect(() => {
    if (['event', 'incidents', 'corrective-actions'].includes(namespace)) {
      prepareForm('scoping');
    }
  }, [eventData])

  useEffect(() => {
    if (['document'].includes(namespace)) {
      prepareForm('scoping');
    }
  }, [documentData])

  useEffect(() => {
    if (['lir'].includes(namespace)) {
      prepareForm('scoping');
    }
  }, [lirData])

  useEffect(() => {
    if (['project'].includes(namespace)) {
      prepareForm('project');
    }
  }, [projectData])

  useEffect(() => {
    if (['sp'].includes(namespace)) {
      prepareForm('scoping');
    }
  }, [spData])

  useEffect(() => {
    if (['im'].includes(namespace)) {
      prepareForm('scoping');
    }
  }, [imData])

  useEffect(() => {
    if (['sci'].includes(namespace)) {
      prepareForm('scoping');
    }
  }, [sciData])

  useEffect(() => {
    if (['bpe'].includes(namespace)) {
      prepareForm('scoping');
    }
  }, [bpeData])

  useEffect(() => {
    if (['gm'].includes(namespace)) {
      prepareForm('scoping');
    }
  }, [gmData])

  const hasKey = (obj, key) => Object.keys(obj).includes(key);
  const goToList = () => {
    const filters = StorageManager.getFilters(module, namespaceAllPath[namespace]);
    const qs = Object.keys(filters).map(key => `${key}=${filters[key]}`).join('&');
    push(
      qs !== '' ? `${`/${mode}/${module}/${namespaceAllPath[namespace]}`}?${qs}` :
        `${`/${mode}/${module}/${namespaceAllPath[namespace]}`}?page=1`
    );
  }

  const pageTitle = useMemo(() => {
    if (viewConfig.title) {
      const title = viewConfig.title[language];
      return title;
    }
    return '';
  }, [viewConfig, namespace, t, language]);

  const extraLinking = useMemo(() => {
    if ((namespace === 'village' || (data || {}).category === 'village')
      && match.params.group === 'location') {
      const categoryOptions = form.location ? form.location.category.options : {};

      return [
        {
          namespace: 'village',
          key: 'associatedMiningSites',
          columns: [
            {
              label: 'ID',
              key: 'datastakeId',
            },
            {
              label: 'Location Name',
              key: 'locationName',
            },
            {
              label: 'Category',
              key: 'category',
              options: categoryOptions,
            }
          ],
          component: 'TABLE',
          title: 'Main associated mine sites',
        },
      ]
    };
    return null;
  }, [namespace, match, data]);

  const breadCrumbs = useMemo(() => {
    return renderBreadCrumbs({
      isAnalysis,
      view: namespace,
      t,
      goTo: push,
      isView: true,
      sourceId,
      mod: module,
      id: data.datastakeId,
    })
  }, [namespace, t, push, sourceId, data, isAnalysis])


  return !isSupported || notFound ? <NotFound /> : (!loading ? (
    <Style className={formatClassname([(isAnalysis || ((namespace === 'location' || namespace === 'village') && groupForm.template === 'risk')) && 'is-analysis'])}>
      <Header
        title={pageTitle}
        breadcrumbs={breadCrumbs}
        // onBack={mode === 'proxy' ? null : goBack}
        onDownload={() => {}}
        tags={headerTags}
        actionButtons={pageActions}
        extraButtons={extraPageActions}
      />
      <div className="view-content">
        <Navigation
          mod={module}
          data={data} match={match} form={form} group={group} subsection={subsection} search={search}></Navigation>
        {groupForm.template ? (
          <Template
            user={user}
            template={groupForm.template}
            namespace={namespace}
            location={{
              locationName: viewConfig.title,
              locationType: (viewConfig.tags || []).find((t) => t.label.en === 'Category'),
            }}
            conf={{
              mod: module,
              group: group,
              form: groupForm,
              data: data[group] ? data[group] : (data || {}),
              allData: data,
              linkingForms: linkingForms || {},
              linkingData: data.linking || {},
              match,
              canEdit: isSupported && canEditAction[namespace]() && selectedProject === PROJECTS.myData,
              mode,
            }}
          />
        ) : (
          <Content
            form={groupForm}
            data={data || {}}
            groupConfig={groups || {}}
            linkingData={(data || {}).linking || {}}
            linkingForms={linkingForms || {}}
            ajaxOptions={emptyArr}
            extraLinking={extraLinking}
          />
        )}
      </div>
      {canInviteCustomer && inviteClient && <Drawer
        destroyOnClose={true}
        title={<DrawerHeader title={t("Invite client")} />}
        open={inviteClient}
        maskClosable={false}
        onClose={() => {
          // ProjectDataGet({ namespace: 'PMEProject', module: 'pme', view: 'project', projectId: id });
          setInviteClient(false);
        }}
        width={CREATE_DRAWER_WIDTH}
        key="customer"
        bodyStyle={{ padding: 0 }}>
        <ProjectCreate
          namespace="Project"
          module="pme"
          view={"customer"}
          showSaveAndNext={false}
          projectId={id}
          info={true}
          edit={true}
          data={data}
          form={form}
          onSubmitted={(type, m) => {
            setInviteClient(false);
          }}
          onCancel={() => setInviteClient(false)}
        />
      </Drawer>}
      <Modal
        title={(
          <ModalHeader
            title={t("Delete subject")}
          />
        )}
        open={deletionVisible}
        onCancel={() => setDeletionVisible(false)}
        onOk={() => {
          setLoading(true);
          namespaceRemove[namespace]({ id: data.id, data: { parentId: data.parent || null, reason: deletionReason } }, (type, m) => {
            displayMessage(type, m);
            setDeletionVisible(false);
            setDeletionReason(null);
            push(`/${mode}/${module}/${namespaceAllPath[namespace]}`);
            setLoading(false);
          });
        }}>
        <Select
          {...getPopupContainer()}
          onChange={ev => setDeletionReason(ev)}
          placeholder={t('Please indicate the reason for deleting this subject')}
          style={{ width: '100%' }}>
          <Select.Option value="Duplicate">
            {t('Duplicate. This subject is already identified')}
          </Select.Option>
          <Select.Option value="Error">
            {t('Issue with core data')}
          </Select.Option>
          <Select.Option value="Non-Existent">
            {t('Subject does not exist and was created by mistake')}
          </Select.Option>
          <Select.Option value="Other">
            {t('Other reason')}
          </Select.Option>
        </Select>
      </Modal>
    </Style>
  ) : <Loading />);
}

const mstp = ({ stakeholder, scl, authentication, events, documents, lir, project, sp, im, sci, bpe, gm }) =>
  ({ stakeholder, scl, authentication, events, documents, lir, project, sp, im, sci, bpe, gm });

const ViewComponent = connect(mstp, actions)(View);

export default function Base() {
  const { namespace } = useParams();

  if (['amp', 'mine-profile', 'ownership-kyc', 'application-form', 'programs', 'esg-assessment'].includes(namespace)) {
    return <ViewTIF />
  }

  return <ViewComponent />
};
